import React from 'react';
import { useTheme, Box } from '@mui/material';
import { 
  LocalizationProvider, 
  MobileDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { 
  dateFormat, 
  formatDate, 
  recoverDate, 
} from '../../../../../utils';

const FilterByDate = ({ setStartDate, setEndDate, settings }) => {
  const { 
      startDate, 
      endDate,
  } = settings;
  return (
    <Box sx={{display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, gap: 1}}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
        <BasicMobileDatePicker 
          label="Start Date" 
          date={startDate} 
          setDate={setStartDate}
        />
        <BasicMobileDatePicker 
          label="End Date"
          date={endDate} 
          setDate={setEndDate}
        />
      </LocalizationProvider>
    </Box>
  );
}

const BasicMobileDatePicker = ({ label, date, setDate }) => {
  const theme = useTheme();
  return (
    <MobileDatePicker
      label={label}
      value={recoverDate(date)}
      onChange={setDate}
      slotProps={{ 
        actionBar: {
          actions: ['clear', 'cancel']
        },
        textField: { 
          size: 'small',
          sx: {
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          },
        },
        mobilePaper: {
          sx: {
            background: theme.palette.mode === 'dark' && theme.palette.darkBlue500,
            borderRadius: "20px",
            border: theme.palette.mode === "dark"
              ? "2px solid #1e2229"
              : "2px solid #AAB4BE",
          },
        },
      }}
      disableFuture
      minDate={recoverDate('01-01-2022')}
      format={dateFormat}
    />
  );
}

export default FilterByDate;

export {
  formatDate,
}